import { render, staticRenderFns } from "./PurchaseAdd.vue?vue&type=template&id=44906538&scoped=true"
import script from "./PurchaseAdd.vue?vue&type=script&lang=js"
export * from "./PurchaseAdd.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAdd.vue?vue&type=style&index=0&id=44906538&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44906538",
  null
  
)

export default component.exports